module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_2_preview.4a38f497.jpg";